import { Button, Modal } from "ant-design-vue";
import { createColumnDatetime, createColumnInput } from "../../../components/table/c-table.logic";
import i18n from "../../../i18n";
import { formatXml } from "../../../utils/util";

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.serviceLog.refUser"), dataIndex: "refUser.fullNameTh" }),
        createColumnDatetime({
            title: () => i18n.global.t("model.serviceLog.datetime"),
            dataIndex: "createDate",
            width: 120
        }),
        createColumnInput({ title: () => i18n.global.t("model.serviceLog.name"), dataIndex: "name" }),
        createColumnInput({ title: () => i18n.global.t("model.serviceLog.messageType"), dataIndex: "messageType" }),
        createColumnInput({ title: () => i18n.global.t("model.serviceLog.ref1"), dataIndex: "ref1" }),
        createColumnInput({ title: () => i18n.global.t("model.serviceLog.ref2"), dataIndex: "ref2" }),
        createColumnInput({ title: () => i18n.global.t("model.serviceLog.codeRefer"), dataIndex: "codeRefer" }),
        {
            title: () => i18n.global.t("model.serviceLog.parameter"),
            dataIndex: "parameter",
            customRender: ({ text }) => {
                if (!text) {
                    return <div></div>;
                }
                let xml = "";
                if (text.length > 0 && text[0].payload) {
                    const payload = text[0].payload;
                    xml = decodeURIComponent(escape(atob(payload)));
                    text[0].xml = xml;
                }
                return (
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                            Modal["info"]({
                                content: <>
                                    <pre>{JSON.stringify(text, null, 4)}</pre>
                                    <pre className="mt-4 ml-4" lang="xml">{formatXml(xml, "   ")}</pre>
                                </>,
                                width: 1200
                            });
                        }}
                    >
                        {i18n.global.t("button.show")}
                    </Button>
                );
            },
            sorter: false,
            width: 120,
            align: "center",
            visible: () => true
        },
        {
            title: () => i18n.global.t("model.serviceLog.result"),
            dataIndex: "result",
            customRender: ({ text }) => {
                if (!text) {
                    return <div></div>;
                }
                return (
                    <Button
                        type="default"
                        size="small"
                        class="btn-success"
                        onClick={() => {
                            Modal["success"]({
                                content: <pre>{JSON.stringify(text, null, 4)}</pre>,
                                width: 800
                            });
                        }}
                    >
                        {i18n.global.t("button.show")}
                    </Button>
                );
            },
            sorter: false,
            width: 100,
            align: "center",
            visible: () => true
        },
        {
            title: () => i18n.global.t("model.serviceLog.error"),
            dataIndex: "error",
            customRender: ({ text }) => {
                if (!text) {
                    return <div></div>;
                }
                return (
                    <Button
                        type="danger"
                        size="small"
                        onClick={() => {
                            Modal["error"]({
                                content: <pre>{text}</pre>,
                                width: 800
                            });
                        }}
                    >
                        {i18n.global.t("button.show")}
                    </Button>
                );
            },
            sorter: false,
            width: 100,
            align: "center",
            visible: () => true
        }
    ];
    return columns;
};

export const createField = () => {
    return [];
};
